export const AGREEMENT_TERM_MONTH_OPTIONS = [12, 24, 36] as const;

export type AgreementTermMonths = (typeof AGREEMENT_TERM_MONTH_OPTIONS)[number];

export function normalizeAgreementTermMonths(value: unknown): AgreementTermMonths {
  if (value === 12 || value === '12') {
    return 12;
  }

  if (value === 36 || value === '36') {
    return 36;
  }

  return 24;
}

export function getAgreementTermMonthsLabel(value: AgreementTermMonths): string {
  return `${value} months`;
}

export function getAgreementTermMonthsText(value: AgreementTermMonths): string {
  if (value === 12) {
    return 'twelve (12) months';
  }

  if (value === 36) {
    return 'thirty-six (36) months';
  }

  return 'twenty-four (24) months';
}
